"use client";

import { FeatureHighlight, MainLink } from "@/components/shared/public";
import { Separator } from "@/components/ui/separator";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { livingSpaceCalcExamp } from "../../../../public/images/floor-plans";
import { livingSpaceCalc } from "../../../../public/images/logos";

const LivingSpaceCalculation = () => {
  const t = useTranslations("sized.spaceCalc");

  return (
    <div className="bg-background" id="wohnflaechenberechnung">
      <div className="gs--page-column py-16">
        <div className="flex flex-col items-center gap-10 md:flex-row">
          <div className="flex flex-col gap-10">
            <FeatureHighlight
              src={livingSpaceCalc}
              alt={"Bemaßte Grundrisse mit Wohnflächenberechnung Detail"}
              title={t("title")}
              text={t("text")}
            />
            <div className="flex flex-col items-center gap-10 md:w-11/12 md:flex-row">
              <div className="flex flex-col gap-10">
                <Separator />
                <p className="text-ring">{t("explanation")}</p>
                <Separator />
              </div>
            </div>
            <div className="flex justify-start">
              <MainLink href={"#"} title={t("linkTitle")} />
            </div>
          </div>

          <Image
            src={livingSpaceCalcExamp}
            alt={"Beispiel Wohnflächenberechnung"}
            className="md:w-1/2 lg:w-full"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
};

export default LivingSpaceCalculation;
